import { useEffect } from 'react'
import { useNetworkState } from '@uidotdev/usehooks'
import { useOfflineQueueProcessor } from './useOfflineMutation'

/**
 * Hook that manages the offline queue processing
 * Automatically processes queue when network comes back online
 */
export function useOfflineQueueManager() {
  const network = useNetworkState()
  const { processQueue } = useOfflineQueueProcessor()

  useEffect(() => {
    if (network.online) {
      // Process queue when network becomes available
      const timer = setTimeout(() => {
        processQueue().catch(console.error)
      }, 1000) // Small delay to ensure network is stable

      return () => clearTimeout(timer)
    }
  }, [network.online, processQueue])

  useEffect(() => {
    if (network.online) {
      // Set up periodic queue processing every 30 seconds when online
      const interval = setInterval(() => {
        processQueue().catch(console.error)
      }, 30000)

      return () => clearInterval(interval)
    }
  }, [network.online, processQueue])

  return {
    isOnline: network.online,
    processQueue: () => processQueue().catch(console.error)
  }
}
